import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW6802Component } from './kymw6802.component';
import { SaveCwsCategoryConvListService } from './api-services/save-cws-category-conv-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

/**
 * ECカテゴリ変換マスタ一覧表画面 モジュール設定クラス
 *
 * @export KYMW6802Module
 * @class KYMW6802Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6802Component,
  ],
  providers: [
    SaveCwsCategoryConvListService,
    FileDownloadConfirmService,
  ],
})
export class KYMW6802Module {

}
